import { render, staticRenderFns } from "./otherIs.vue?vue&type=template&id=fce8fa0a"
import script from "./otherIs.vue?vue&type=script&lang=js"
export * from "./otherIs.vue?vue&type=script&lang=js"
import style0 from "./otherIs.vue?vue&type=style&index=0&id=fce8fa0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports